//Import Mixpanel SDK
import { IContextProvider } from "@uxp";
import mixpanel from "mixpanel-browser";
 
let initialized = false;
function initialize() {
    if (initialized) return;
    mixpanel.init("c70e4da93dae5569d322e354a5f45840", {
        debug: true,
        track_pageview: true,
        persistence: "localStorage",
      });
      initialized = true;
}
// Near entry of your product, init Mixpanel


let identified =false;

function identifyUser(context:IContextProvider) {
    if (identified) return;
    try {

        mixpanel.identify(context.userKey);
    } catch(e) {
        console.error('mp',e);
        identified = true;
    }
}
export function trackAnalytics(context:IContextProvider,event:string,props:any) {
    if (!context) {
        console.warn('tracking without context');
        return;
    }
    try {
        initialize();
        identifyUser(context);
        mixpanel.track(event,props);
    } catch(e) {
        console.error('mp1',e);
    }
}